export const query = graphql`
  fragment bundleSummary on BundleSummary {
    bundle_id
    app_name
    app_url
    company
    updated
    platform
    category
    since_num_months
    reports_received
    attacks_blocked
    num_top_cities
    app_installs
    is_app_protection_customer
    attack_cat_monthly {
      name
      device_spyware
      captive_portal
      misconfiguration
      unknown
      corporate_appliance
    }
    attack_cat_all_time {
      device_spyware
      captive_portal
      misconfiguration
      unknown
      corporate_appliance
    }
    management {
      name
      role
      img
    }
    cities {
      city
      lat
      long
      count
      attack_cat {
        device_spyware
        captive_portal
        misconfiguration
        unknown
        corporate_appliance
      }
    }
    geo {
      lat
      long
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/bundleSummary.js